var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 32c-5.172 0-10.132-1.686-13.789-4.686S0 20.244 0 16c0-4.243 2.054-8.313 5.711-11.314C9.368 1.686 14.328 0 19.5 0v32Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.131 15.985 3.637-3.636-1.213-1.213-3.636 3.637-3.637-3.636-1.212 1.212 3.637 3.636-3.637 3.637 1.212 1.212 3.637-3.636 3.636 3.636 1.213-1.212-3.637-3.637Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.aa537f0554c07ace006c6d6c98e626d9.svg";
export { ForwardRef as ReactComponent };